﻿{
  "version": 1,
  "gameId": "daberna",
  "economy": { "offlineEntryCoins": 0, "offlineWinCoins": 0, "offlineWinXp": 20, "offlineLossXp": 0, "onlineEntryCoins": 0, "onlineWinCoins": 0, "onlineWinXp": 0, "onlineLossXp": 0 },
  "tutorial": {
    "view": "rules",
    "navigationLabelKey": "daberna.rules.navigationLabel",
    "kickerKey": "daberna.rules.kicker",
    "titleKey": "daberna.rules.title",
    "summaryKey": "daberna.rules.summary",
    "sections": [
      { "id": "ticket", "key": "daberna.rules.ticket" },
      { "id": "call", "key": "daberna.rules.call" },
      { "id": "mark", "key": "daberna.rules.mark" },
      { "id": "extra-tickets", "key": "daberna.rules.extraTickets" },
      { "id": "line", "key": "daberna.rules.line" },
      { "id": "bingo", "key": "daberna.rules.bingo" }
    ],
    "settingsAccess": false
  },
  "cosmetics": {}
}
